import { Injectable } from '@angular/core';
import { SmartCaptchaService } from '@core/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalMessageActions, GlobalMessageType } from '@spartacus/core';
import { SendCodeResponse } from '@user/const';
import { CustomUserActions, OccLoginService } from '@user/data-access';
import { from, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

@Injectable()
export class LoginEffects {
  sendSms$: Observable<
    | GlobalMessageActions.AddMessage
    | CustomUserActions.RequestAuthCodeSuccess
    | CustomUserActions.RequestAuthCodeFailure
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomUserActions.REQUEST_AUTH_CODE),
      mergeMap((action: CustomUserActions.RequestAuthCode) => {
        return this.smartCaptchaService.execute().pipe(
          switchMap((captchaToken: string | undefined) => {
            return this.occLoginService.sendCode(action.phone, captchaToken, action.deliveryChannel).pipe(
              map((payload: SendCodeResponse) => {
                const withAdditionData = {
                  phoneNumber: action.phone,
                  timestamp: Date.now(),
                  ...payload,
                };

                return new CustomUserActions.RequestAuthCodeSuccess(withAdditionData);
              }),
              catchError((error: any) => {
                const actions: Array<CustomUserActions.RequestAuthCodeFailure | GlobalMessageActions.AddMessage> = [
                  new CustomUserActions.RequestAuthCodeFailure(error),
                ];

                if (error?.error?.errors) {
                  error.error.errors.forEach((err: any) => {
                    if (err.message) {
                      actions.push(
                        new GlobalMessageActions.AddMessage({
                          text: { raw: err.message },
                          type: GlobalMessageType.MSG_TYPE_ERROR,
                        }),
                      );
                    }
                  });
                }

                return from(actions);
              }),
            );
          }),
          catchError(() => of(new CustomUserActions.RequestAuthCodeFailure(null))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occLoginService: OccLoginService,
    private smartCaptchaService: SmartCaptchaService,
  ) {}
}
